import api from '@/lib/axios';
import type { Tenant, CreateTenantDTO, UpdateTenantDTO, ApiResponse, LaravelPaginator } from '@/types';

/**
 * Service de Tenants
 * Rotas: /v1/propriedades/*
 */
export const tenantsService = {
  /**
   * Listar todos os tenants
   * GET /v1/propriedades
   */
  async list(): Promise<Tenant[]> {
    const { data } = await api.get<ApiResponse<LaravelPaginator<Tenant>>>('/v1/propriedades');
    return data.data.data;
  },

  /**
   * Obter tenant por ID
   * GET /v1/propriedades/:id
   */
  async get(id: number): Promise<Tenant> {
    const { data } = await api.get<ApiResponse<Tenant>>(`/v1/propriedades/${id}`);
    return data.data;
  },

  /**
   * Criar novo tenant
   * POST /v1/propriedades
   */
  async create(payload: CreateTenantDTO): Promise<Tenant> {
    const { data } = await api.post<ApiResponse<Tenant>>('/v1/propriedades', payload);
    return data.data;
  },

  /**
   * Atualizar tenant
   * PUT /v1/propriedades/:id
   */
  async update(id: number, payload: UpdateTenantDTO): Promise<Tenant> {
    const { data } = await api.put<ApiResponse<Tenant>>(`/v1/propriedades/${id}`, payload);
    return data.data;
  },

  /**
   * Deletar tenant
   * DELETE /v1/propriedades/:id
   */
  async delete(id: number): Promise<void> {
    await api.delete(`/v1/propriedades/${id}`);
  },
};
